var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMecanismoFocalBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM428.57,428.54A243.14,243.14,0,1,1,480.87,351,243.34,243.34,0,0,1,428.57,428.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,78.52A177.78,177.78,0,0,0,177.31,96.8a5.37,5.37,0,0,0-1.27.63c-58.53,29.4-98.8,90-98.8,159.85a178.41,178.41,0,0,0,6.35,47.25,6.38,6.38,0,0,0,.19.72,179.36,179.36,0,0,0,138.7,127.63,5.08,5.08,0,0,0,.85.16A178.6,178.6,0,0,0,256,436c98.57,0,178.76-80.19,178.76-178.76S354.57,78.52,256,78.52Zm.21,271.63c-15.57,38.1-29.94,63.91-34.83,72.32A169.37,169.37,0,0,1,93.87,304.18c41.82-74.05,98-108,137.88-123.52,33.53-13,61.51-15.5,72.86-15.95C295.57,242.07,273.41,308,256.21,350.15ZM307,146.94c-25.21-27.59-79.25-41.5-110.7-47.52A168.86,168.86,0,0,1,305.63,96C306.3,104.57,308,129.64,307,146.94ZM424.76,257.28a167.69,167.69,0,0,1-17,73.81c-2.07-37.32-16-109.37-86.43-168.87,36.47-6.79,71.12,2.91,77.2,4.76A167.8,167.8,0,0,1,424.76,257.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMecanismoFocalBlanco);
export default __webpack_public_path__ + "static/media/mecanismo_focal_blanco.7cf13c3f58b9283db877923ee8cc8f80.svg";
export { ForwardRef as ReactComponent };